import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';
import { STORAGE } from '../../shared/constants/storage.constants';
import { getTenantIdFromRouter } from '../utils/tenant-route.util';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const authService = inject(AuthService);

  // Prefer tenant from current route (e.g. /:tenantId/leads); fall back to stored tenant (e.g. after MFA on /mfa)
  let tenantId = getTenantIdFromRouter(router);
  if (!tenantId) {
    const stored = authService.getStoredTenantId();
    if (stored) tenantId = stored;
  }

  // Get token from localStorage
  const token = storageService.get(STORAGE.ACCESS_TOKEN);

  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (tenantId) headers['x-tenant-id'] = tenantId;

  if (Object.keys(headers).length > 0) {
    req = req.clone({ setHeaders: headers });
  }

  return next(req);
};
